// Import model
import { ContentResult } from '../models/ContentResult';

// Import base class serializer
import { EntityOwnedModelSerializer } from './EntityOwnedModelSerializer';

// Import dependency types (models and enums used in properties)
import { AiContentMessage } from '../models/AiContentMessage';

// Import dependency serializers (for complex types)
import { AiContentMessageSerializer } from './AiContentMessageSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ContentResult - handles JSON serialization and deserialization with type validation
 */
export class ContentResultSerializer {
  /**
   * Deserializes a JSON string into a ContentResult instance
   */
  static deserialize(json: string): ContentResult {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ContentResult instance
   */
  static fromObject(obj: any): ContentResult {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ContentResult');
    }


    const instance: ContentResult = {
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      errorMessage: obj['ErrorMessage'] as string | undefined,
      flowRunId: obj['flowRunId'] as string | undefined,
      flowRunIdName: obj['flowRunId|Name'] as string | undefined,
      result: obj['result'] ? AiContentMessageSerializer.fromObject(obj['result']) : undefined as any,
      resultType: obj['resultType'] as string | undefined,
      isSuccess: obj['IsSuccess'] as boolean | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ContentResult instances
   */
  static deserializeArray(json: string): ContentResult[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ContentResult instance to a JSON string
   */
  static serialize(instance: ContentResult): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ContentResult instance to a plain object
   */
  static toObject(instance: ContentResult): any {
    return {
      'name': instance.name,
      'description': instance.description,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'ErrorMessage': instance.errorMessage,
      'flowRunId': instance.flowRunId,
      'flowRunId|Name': instance.flowRunIdName,
      'result': instance.result ? AiContentMessageSerializer.toObject(instance.result) : undefined,
      'resultType': instance.resultType,
      'IsSuccess': instance.isSuccess,
    };
  }

  /**
   * Serializes an array of ContentResult instances to a JSON string
   */
  static serializeArray(instances: ContentResult[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
